import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f4ae21e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "privacy__header" }
const _hoisted_2 = { class: "privacy__body" }
const _hoisted_3 = { class: "privacy__body_title" }
const _hoisted_4 = { class: "privacy__body_text" }
const _hoisted_5 = { class: "privacy__body_text" }
const _hoisted_6 = { class: "privacy__body_main" }
const _hoisted_7 = { class: "privacy__body_label" }
const _hoisted_8 = { class: "privacy__body_label" }
const _hoisted_9 = { class: "privacy__body_main" }
const _hoisted_10 = { class: "privacy__body_main" }
const _hoisted_11 = { class: "privacy__body_label" }
const _hoisted_12 = { class: "privacy__body_label" }
const _hoisted_13 = { class: "privacy__body_main" }
const _hoisted_14 = { class: "privacy__body_label" }
const _hoisted_15 = { class: "privacy__body_main" }
const _hoisted_16 = { class: "privacy__body_label" }
const _hoisted_17 = { class: "privacy__body_main" }
const _hoisted_18 = { class: "privacy__body_label" }
const _hoisted_19 = { class: "privacy__body_label" }
const _hoisted_20 = { class: "privacy__body_label" }
const _hoisted_21 = { class: "privacy__body_main" }
const _hoisted_22 = { class: "privacy__body_label" }
const _hoisted_23 = { class: "privacy__body_label" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "privacy__body_label" }, " +48500468674 ", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "privacy__body_label" }, " Email: info@zetreex.com ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_close_modal_layout = _resolveComponent("close-modal-layout")!

  return (_openBlock(), _createBlock(_Transition, {
    name: "modalTransition",
    duration: 600
  }, {
    default: _withCtx(() => [
      (_ctx.getModalPrivacy)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "modal",
            onClick: _cache[1] || (_cache[1] = () => _ctx.setModalPrivacy(false))
          }, [
            _createElementVNode("div", {
              class: "modal__privacy_content",
              onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
            }, [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_close_modal_layout, { setModal: _ctx.setModalPrivacy }, null, 8, ["setModal"])
              ]),
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.getStaticLanguage.privacyTitle), 1),
                _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.getStaticLanguage.privacyText1), 1),
                _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.getStaticLanguage.privacyText2), 1),
                _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.getStaticLanguage.privacyMain1), 1),
                _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.getStaticLanguage.privacyLabel1), 1),
                _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.getStaticLanguage.privacyLabel2), 1),
                _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.getStaticLanguage.privacyMain2), 1),
                _createElementVNode("ul", null, [
                  _createElementVNode("li", null, _toDisplayString(_ctx.getStaticLanguage.privacyLi1), 1),
                  _createElementVNode("li", null, _toDisplayString(_ctx.getStaticLanguage.privacyLi2), 1)
                ]),
                _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.getStaticLanguage.privacyMain3), 1),
                _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.getStaticLanguage.privacyLabel3), 1),
                _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.getStaticLanguage.privacyLabel4), 1),
                _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.getStaticLanguage.privacyMain4), 1),
                _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.getStaticLanguage.privacyLabel5), 1),
                _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.getStaticLanguage.privacyMain5), 1),
                _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.getStaticLanguage.privacyLabel6), 1),
                _createElementVNode("ul", null, [
                  _createElementVNode("li", null, _toDisplayString(_ctx.getStaticLanguage.privacyLi3), 1),
                  _createElementVNode("li", null, _toDisplayString(_ctx.getStaticLanguage.privacyLi4), 1),
                  _createElementVNode("li", null, _toDisplayString(_ctx.getStaticLanguage.privacyLi5), 1),
                  _createElementVNode("li", null, _toDisplayString(_ctx.getStaticLanguage.privacyLi6), 1),
                  _createElementVNode("li", null, _toDisplayString(_ctx.getStaticLanguage.privacyLi7), 1),
                  _createElementVNode("li", null, _toDisplayString(_ctx.getStaticLanguage.privacyLi8), 1),
                  _createElementVNode("li", null, _toDisplayString(_ctx.getStaticLanguage.privacyLi9), 1),
                  _createElementVNode("li", null, _toDisplayString(_ctx.getStaticLanguage.privacyLi10), 1),
                  _createElementVNode("li", null, _toDisplayString(_ctx.getStaticLanguage.privacyLi11), 1)
                ]),
                _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.getStaticLanguage.privacyMain6), 1),
                _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.getStaticLanguage.privacyLabel7), 1),
                _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.getStaticLanguage.privacyLabel8), 1),
                _createElementVNode("ul", null, [
                  _createElementVNode("li", null, _toDisplayString(_ctx.getStaticLanguage.privacyLi12), 1),
                  _createElementVNode("li", null, _toDisplayString(_ctx.getStaticLanguage.privacyLi13), 1)
                ]),
                _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.getStaticLanguage.privacyLabel9), 1),
                _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.getStaticLanguage.privacyMain7), 1),
                _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.getStaticLanguage.privacyNameCompany), 1),
                _createElementVNode("p", _hoisted_23, _toDisplayString(_ctx.getStaticLanguage.privacyLocaleCompany), 1),
                _hoisted_24,
                _hoisted_25
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}